var _rect, _path, _path2, _rect2, _rect3, _rect4, _circle, _circle2, _rect5, _path3, _path4, _rect6, _rect7, _rect8, _rect9, _circle3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.865,
    y: -6.001,
    width: 104.891,
    height: 157.946,
    rx: 5,
    ry: 5,
    transform: "translate(23.339 169.282) rotate(-90)",
    fill: "#f46275"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.837,120.417V25.526a5,5,0,0,1,5-5h-15.5a5,5,0,0,0-5,5v94.891a5,5,0,0,0,5,5h15.5A5,5,0,0,1,32.837,120.417Z",
    fill: "#f43075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.783,120.417V25.526a5,5,0,0,0-5-5h15.5a5,5,0,0,1,5,5v94.891a5,5,0,0,1-5,5h-15.5A5,5,0,0,0,159.783,120.417Z",
    fill: "#f48875"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89.643,
    y: -28.723,
    width: 13.333,
    height: 157.946,
    transform: "translate(46.06 146.56) rotate(-90)",
    fill: "#63bce7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.337,
    y: 43.583,
    width: 15.5,
    height: 13.333,
    fill: "#6377e7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 159.783,
    y: 43.583,
    width: 15.5,
    height: 13.333,
    fill: "#63e2e7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153.303,
    cy: 100.593,
    r: 9.966,
    fill: "#f8af23"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.415,
    cy: 100.593,
    r: 9.966,
    fill: "#63bce7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 49.271,
    y: 81.968,
    width: 11.882,
    height: 37.25,
    transform: "translate(-45.381 155.805) rotate(-90)",
    fill: "#f8af23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.283,29.456V73.971l-8.762-10.28a10.213,10.213,0,0,0-14.356-1.144h0A10.213,10.213,0,0,0,151.021,76.9l19.933,23.385s-5.949,25.106,9.733,39.451H225.02l-3.93-53.933c-.472-4.981-3.543-9.194-6.666-12.679Z",
    fill: "#f8af23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.09,85.806c-.472-4.981-3.543-9.194-6.666-12.679L175.283,29.456V46.75l23.641,26.377c3.123,3.485,6.195,7.7,6.666,12.679l3.93,53.933h15.5Z",
    fill: "#f8d323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 161.078,
    y: 139.739,
    width: 77.584,
    height: 31.999,
    fill: "#9e9e9e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 223.163,
    y: 139.739,
    width: 15.5,
    height: 31.999,
    fill: "#cecece"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 165.676,
    y: 171.738,
    width: 68.39,
    height: 52.763,
    fill: "#63bce7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 218.565,
    y: 171.738,
    width: 15.5,
    height: 52.763,
    fill: "#63e2e7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.212,
    cy: 56.917,
    r: 26.348,
    fill: "#f8af23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.3,89.127a11.466,11.466,0,1,0,11.466,11.466A11.479,11.479,0,0,0,153.3,89.127Zm0,19.931a8.466,8.466,0,1,1,8.466-8.465A8.475,8.475,0,0,1,153.3,109.059Z",
    fill: "#3f3679"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.415,89.127a11.466,11.466,0,1,0,11.465,11.466A11.479,11.479,0,0,0,127.415,89.127Zm0,19.931a8.466,8.466,0,1,1,8.465-8.465A8.475,8.475,0,0,1,127.415,109.059Z",
    fill: "#3f3679"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.837,93.152H36.587a1.5,1.5,0,0,0-1.5,1.5v11.882a1.5,1.5,0,0,0,1.5,1.5h37.25a1.5,1.5,0,0,0,1.5-1.5V94.652A1.5,1.5,0,0,0,73.837,93.152Zm-1.5,11.882H38.087V96.152h34.25Z",
    fill: "#3f3679"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M215.807,157.238h9.213a1.5,1.5,0,0,0,0-3h-9.213a1.5,1.5,0,0,0,0,3Z",
    fill: "#3f3679"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.323,233.974h-18a1.5,1.5,0,0,0,0,3h18a1.5,1.5,0,0,0,0-3Z",
    fill: "#3f3679"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M246.68,233.974h-18a1.5,1.5,0,1,0,0,3h18a1.5,1.5,0,0,0,0-3Z",
    fill: "#3f3679"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.479,233.974H37.521a1.5,1.5,0,1,0,0,3H218.479a1.5,1.5,0,1,0,0-3Z",
    fill: "#3f3679"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32,226H246.68a1.5,1.5,0,0,0,0-3H235.565V173.238h3.1a1.5,1.5,0,0,0,1.5-1.5v-32a1.5,1.5,0,0,0-1.5-1.5H226.414l-3.831-52.575c-.533-5.63-4.044-10.192-7.042-13.538L176.783,28.882V25.526a6.508,6.508,0,0,0-6.5-6.5H22.337a6.508,6.508,0,0,0-6.5,6.5v94.891a6.508,6.508,0,0,0,6.5,6.5H170.283c.156,0,.31-.032.466-.043a34.171,34.171,0,0,0,6.4,11.365H161.078a1.5,1.5,0,0,0-1.5,1.5v32a1.5,1.5,0,0,0,1.5,1.5h3.1V223H9.32a1.5,1.5,0,0,0,0,3Zm73.7-170.584a27.638,27.638,0,0,0-2.605-10.333h93.369V55.417Zm-55.613,0H18.837V45.083H30.011A27.643,27.643,0,0,0,27.406,55.417ZM55.212,32.068A24.848,24.848,0,1,1,30.364,56.917,24.877,24.877,0,0,1,55.212,32.068ZM22.337,22.026H170.283a3.5,3.5,0,0,1,3.5,3.5V42.083H78.764a27.817,27.817,0,0,0-47.1,0H18.837V25.526A3.5,3.5,0,0,1,22.337,22.026Zm0,101.891a3.5,3.5,0,0,1-3.5-3.5v-62h8.569a27.847,27.847,0,0,0,55.613,0h90.764V69.9l-6.121-7.181A11.683,11.683,0,0,0,149.88,77.876L169.334,100.7a57.778,57.778,0,0,0-.892,14.022,47.679,47.679,0,0,0,1.419,9.2Zm149.105-9.288a54.01,54.01,0,0,1,.972-14,1.5,1.5,0,0,0-.318-1.318L152.163,75.93a8.683,8.683,0,0,1,13.216-11.265l8.763,10.279,16.638,19.519a1.5,1.5,0,0,0,2.283-1.946l-16.279-19.1V33.377l36.523,40.751c2.691,3,5.839,7.061,6.287,11.787l3.813,52.324H181.277C175.354,132.6,172.046,124.661,171.442,114.629Zm-8.864,42.609h43.245a1.5,1.5,0,0,0,0-3H162.578v-13h74.585v29H162.578Zm4.6,16h65.39V223h-65.39Z",
    fill: "#3f3679"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.371,56.9v7.658a2.1,2.1,0,0,1-.671,1.553,2.2,2.2,0,0,1-1.592.658H57.37v5.4a2.112,2.112,0,0,1-.658,1.566,2.145,2.145,0,0,1-1.553.645,2.206,2.206,0,0,1-1.605-.645,2.111,2.111,0,0,1-.658-1.566V66.72H46.212a2.142,2.142,0,0,1-1.553-.645A2.111,2.111,0,0,1,44,64.509,2.2,2.2,0,0,1,46.212,62.3H61.844V59.114H46.264a2.154,2.154,0,0,1-1.566-.632,2.117,2.117,0,0,1-.645-1.579V49.271a2.2,2.2,0,0,1,2.211-2.211H52.9v-5.4a2.183,2.183,0,0,1,2.29-2.211,2.1,2.1,0,0,1,1.54.645,2.133,2.133,0,0,1,.645,1.566v5.4h6.79a2.2,2.2,0,0,1,1.592.658,2.1,2.1,0,0,1,.671,1.553,2.292,2.292,0,0,1-2.263,2.263H48.528v3.158h15.58a2.2,2.2,0,0,1,1.592.658A2.1,2.1,0,0,1,66.371,56.9Z",
    fill: "#3f3679"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.861033e93730b478ee2f90a548c427e3.svg";
export { ForwardRef as ReactComponent };